import React, {useState} from "react";
import { useSelector } from "react-redux";
import { Redirect } from 'react-router-dom';

import SuscriptionCard from "../components/SuscriptionCard/SuscriptionCard"
import { authGetClient } from "../actions/auth-action";
import '../css/ManageProducts.css'
import { useGetProductSuscriptions } from "../hooks/useOfClient";
import AuthVerify from "../components/AuthVerify";
import PropTypes from 'prop-types';

function ManageProducts(props) {

    const userClientId = props.location.state === null ? authGetClient() : props.location.state.clientId;
    const { user: currentAuth } = useSelector((state) => state.auth);
   
    const [clientProducts, setClientProducts] = useState(null);        
    useGetProductSuscriptions(userClientId, clientProducts, setClientProducts);

    return (
        <div className="tab-content wow fadeIn" >
            <AuthVerify currentToken={currentAuth} />
            <div role="tabpanel" className="tab-pane fade show active" id="yearly">
                <div className="row justify-content-center">
                    { clientProducts?.map((item, index) => 
                        <SuscriptionCard key={index} product={item} clientId={userClientId} showWorkwith={item.name === "CRCU"}/>
                    )}
                </div>
            </div>
        </div>
    );
}
ManageProducts.propTypes = {
    location: PropTypes.object.isRequired,
};
export default ManageProducts;